import { render, staticRenderFns } from "./progress-summary.vue?vue&type=template&id=53d274c8"
import script from "./progress-summary.vue?vue&type=script&lang=js"
export * from "./progress-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports